<template>
  <footer class="footer position-relative">
    <div class="uk-grid-collapse footer-content" uk-grid>

      <!-- Logo & Copyright -->
      <div class="uk-width-expand@s uk-first-column d-flex align-item-center footer-logo-section">
        <small v-if="!hide_copyright_notice">
          <BrandSignature
            :src="logoFooter"
            appearance="plain"
            class="footer-brand-signature"
            placement="beside"
            size="small"
            theme="muted"
          />
          <span class="footer-copyright">© {{ $t('general.all_rights_reserved') }}.</span>
        </small>
        <small v-else style="visibility: hidden;">&nbsp;</small> <!-- Yer tutucu -->
      </div>

      <!-- Clarification Link -->
      <div class="mt-2 mr-4 footer-clarification">
        <a v-if="!hide_copyright_notice" @click="openInformationUser">
          {{ $t('general.clarification_Text') }}
        </a>
        <span v-else style="visibility: hidden;">&nbsp;</span> <!-- Yer tutucu -->
      </div>

      <!-- Social Icons -->
      <div class="uk-width-auto@s d-flex align-items-center footer-social">
        <nav class="footer-nav-icon">
          <ul>
            <li>
              <a :href="socialLinks.linkedin" target="_blank"><i class="icon-brand-linkedin"></i></a>
            </li>
            <li>
              <a :href="socialLinks.instagram" target="_blank"><i class="icon-brand-instagram"></i></a>
            </li>
            <li>
              <a :href="socialLinks.facebook" target="_blank"><i class="icon-brand-facebook"></i></a>
            </li>
            <li>
              <a :href="socialLinks.youtube" target="_blank"><i class="icon-brand-youtube"></i></a>
            </li>
          </ul>
        </nav>
      </div>
      <!-- <div v-if="$roleCount() > 1">
      <AnzeraChatBot/>
      </div> -->
      <!-- Quick Share Component -->
      <QuickShare v-if="isCompanyPage" />

    </div>

    <InformationModal ref="informationModalRef" v-if="showPreview" @modal-closed="onModalClosed" />
  </footer>
</template>

<script>
import i18nService from "@/core/services/i18n.service.js";
import InformationModal from "@/view/components/modal/informationModal.vue";
import QuickShare from "@/view/components/QuickShare.vue";
import AnzeraChatBot from "@/view/components/chatbot/AnzeraChatBot.vue";
import BrandSignature from "@/view/layouts/shared/components/BrandSignature.vue";
import company_module, {
  MODULE_NAME as COMPANY_MODULE_NAME
} from "@/core/services/store/company.module";
import store from "@/core/services";

export default {
  name: "Footer",
  components: {
    BrandSignature,
    InformationModal,
    QuickShare,
    AnzeraChatBot
  },
  props: {
    showMenu: {
      required: false,
      default: true
    },
    isCompanyPage: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      hide_copyright_notice: false,
      showPreview: false,
      subdomain: null,
      socialLinks: {
        linkedin: 'https://tr.linkedin.com/company/anzeraogrenmeteknolojileri/',
        instagram: 'https://www.instagram.com/anzeraofficial/',
        facebook: 'https://tr-tr.facebook.com/pages/category/Computer-Company/Anzera-%C3%96%C4%9Frenme-Teknolojileri-601130579942407/',
        youtube: 'https://www.youtube.com/channel/UCYlNDP2rbHqxD95wbsOSyKw'
      },
      defaultSocialLinks: {
        linkedin: 'https://tr.linkedin.com/company/anzeraogrenmeteknolojileri/',
        instagram: 'https://www.instagram.com/anzeraofficial/',
        facebook: 'https://tr-tr.facebook.com/pages/category/Computer-Company/Anzera-%C3%96%C4%9Frenme-Teknolojileri-601130579942407/',
        youtube: 'https://www.youtube.com/channel/UCYlNDP2rbHqxD95wbsOSyKw'
      }
    }
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(COMPANY_MODULE_NAME, company_module);
  },
  computed: {
    company() {
      return store.getters[COMPANY_MODULE_NAME + "/" + "SELF"];
    },
    logoFooter() {
      return process.env.BASE_URL + "media/images/new-logo-dark.svg";
    },
    activeLanguage() {
      return i18nService.getActiveLanguage();
    },
  },
  methods: {
    async openInformationUser() {
      // Modal'ı DOM'a eklemek için showPreview'ı true yap
      if (!this.showPreview) {
        this.showPreview = true;
        await this.$nextTick();
      }

      if (this.$refs.informationModalRef && typeof this.$refs.informationModalRef.fetchLegalTexts === 'function') {
        await this.$refs.informationModalRef.fetchLegalTexts();
      }
    },
    setSocialLinks(companyData) {
      if (!companyData || !companyData.settings) return;
      const themeItem = companyData.settings.find(x => x.key === 'theme_settings');
      this.hide_copyright_notice = companyData.settings?.find(x => x.key === 'hide_copyright_notice')?.value;
      if (!themeItem || !themeItem.value) return;

      const theme = themeItem.value;

      // sosyal medya linklerini reactive objeye ata
      this.socialLinks.linkedin = theme.linkedinLink || this.defaultSocialLinks.linkedin;
      this.socialLinks.youtube = theme.youtubeLink || this.defaultSocialLinks.youtube;
      this.socialLinks.facebook = theme.facebookLink || this.defaultSocialLinks.facebook;
      this.socialLinks.instagram = theme.instagramLink || this.defaultSocialLinks.instagram;

    },
    onModalClosed() {
      this.showPreview = false;
    },
  },
  mounted() {
    this.subdomain = window.location.hostname;
    if (this.company) {
      this.setSocialLinks(this.company);
    }
    this.$root.$on('company:updated', this.setSocialLinks);

    if (!window.localStorage.getItem("informationText")) {
      // kvkk+privacy metin gösterimleri
      this.showPreview = true
    }
  },
  beforeDestroy() {
    this.$root.$off('company:updated', this.setSocialLinks);
  },
  watch: {
    company(newVal) {
      if (newVal) {
        this.setSocialLinks(newVal);
      }
    }
  }
}
</script>

<style scoped>
.footer {
  padding-top: 12px;
  border-top: 1px solid #e4e4e4;

  p {
    color: #656565;
  }
}

.footer small {
  font-weight: 300;
}

.footer-brand-signature {
  --brand-logo-width: 108px;
  align-items: center;
}

.footer-copyright {
  padding-left: 10px;
  border-left: 1px solid #d9dce4;
}

/* Mobile responsive styles */
@media (max-width: 767px) {
  .footer {
    padding: 10px 16px;
    border-top: 1px solid #e8e8e8;
  }

  .footer-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
  }

  .footer-logo-section {
    justify-content: center;
    order: 1;
    width: 100%;
  }

  .footer-logo-section small {
    font-size: 11px;
    color: #999;
    display: flex;
    align-items: center;
    gap: 6px;
    justify-content: center;
  }

  .footer-logo-section img {
    width: 70px;
    height: auto;
  }

  .footer-brand-signature {
    --brand-logo-width: 70px;
  }

  .footer-copyright {
    padding-left: 0;
    border-left: 0;
  }

  .footer-clarification {
    margin: 0;
    order: 2;
    width: 100%;
  }

  .footer-clarification a {
    font-size: 11px;
    color: #888;
    text-decoration: underline;
  }

  .footer-social {
    justify-content: center;
    order: 3;
    width: 100%;
  }

  .footer-nav-icon ul {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .footer-nav-icon ul li {
    margin: 0;
  }

  .footer-nav-icon ul li a {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
  }

  .footer-nav-icon ul li a i {
    font-size: 16px;
    color: #999;
  }
}

/* Desktop styles - Reset order properties */
@media (min-width: 768px) {
  .footer-logo-section {
    order: unset;
  }

  .footer-logo-section small {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    font-size: 13px;
  }

  .footer-clarification {
    order: unset;
  }

  .footer-social {
    order: unset;
  }
}

/* Tablet responsive styles */
@media (min-width: 768px) and (max-width: 1023px) {
  .footer {
    padding: 15px 20px;
  }

  .footer-content {
    gap: 10px;
  }

  .footer-logo-section small {
    font-size: 13px;
  }

  .footer-clarification a {
    font-size: 14px;
  }
}
</style>
